import httpClient from "common/api/httpClient";
import { IResourcesStoreInfo } from "../types";

export const fetchResourcesStoreInfo = async () => {
  //resources are accessed from "developer" with authenticated users, and from "fill" with public token.
  //as this is shared by both modes, I need to manage both auth methods. in the future when we decouple redux state
  //from form render, we could have different methods for each feature with correct auth method.
  //as a workaround meanwhile, I prioritize public token auth before jwt auth
  const response = await httpClient.get<IResourcesStoreInfo>(
    "Resources/ResourcesStore/AccessToken"
  );

  return response.data;
};
